import { render, staticRenderFns } from "./MigrationsList.vue?vue&type=template&id=536fae3a&scoped=true"
import script from "./MigrationsList.vue?vue&type=script&lang=js"
export * from "./MigrationsList.vue?vue&type=script&lang=js"
import style0 from "./MigrationsList.vue?vue&type=style&index=0&id=536fae3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536fae3a",
  null
  
)

export default component.exports